import Player from '@vimeo/player';
const videos = document.querySelectorAll('[data-behaviour="video"]');

if (videos.length > 0) {

    videos.forEach((video) => {

        const playButton = video.querySelector('[data-action="play"]');
        const iframe = video.querySelector('iframe');
        const type = video.getAttribute('data-type');

        let player = false;

        if(iframe && type === 'vimeo') {
            player = new Player(iframe);
        }

        if(playButton) {

            playButton.addEventListener('click', (ev) => {
                ev.preventDefault();
                video.classList.add('video--is-playing');

                if(player) {
                    player.play();
                }

                if(type === 'youtube') {
                    iframe.src += '&autoplay=1';
                }
               
            });

        }

    });

}